module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/2/4-cd8b4c6a6cc20521997bf83ced055930.jpg";